import * as React from "react";
import { BaseBlock, broadcastBlockLoad } from "sb-resp-block-lib";
import { BaseDict } from "./dict";
import { config } from "./config";
import { MyPulseBets } from "./MyPulseBets";
import { MyPulseBetsData } from "./data";
let _;
let PageMethodsMock;
let MasterEventsPageMethodsMock;
let BettingHistoryPageMethodsMock;
let BasePlayByPlayMock;
let UserInfoMock;
let BettingPageMethodsMock;
let OddsMock;
let _localMocks;
if (process.env.NODE_ENV === "development") {
    _ = require("sb-legacy-integration/lib-esm/mocks");
    _localMocks = require("../../mocks");
    PageMethodsMock = _.PageMethodsMock;
    MasterEventsPageMethodsMock = _localMocks.MasterEventsPageMethodsMock;
    BettingHistoryPageMethodsMock = _localMocks.BettingHistoryPageMethodsMock;
    BasePlayByPlayMock = _localMocks.BasePlayByPlayMock;
    UserInfoMock = _.UserInfoMock;
    OddsMock = _.OddsMock;
    BettingPageMethodsMock = _localMocks.BettingPageMethodsMock;
}
export class MyPulseBetsRoot extends BaseBlock {
    // constructor sets defaults
    constructor(domId, options = {
        dict: BaseDict,
        cms: {},
        navHandler: {},
        dataProvider: {},
        betSlipUtil: {},
        oddsUtil: {},
        facade: {}
    }) {
        super(domId, options);
        if (process.env.NODE_ENV === "development") {
            // setup data mocks for debug build
            this.dataProvider = new MyPulseBetsData({
                pageMethods: new PageMethodsMock(),
                masterEventsPageMethoods: new MasterEventsPageMethodsMock(),
                bettingHistoryPageMethods: new BettingHistoryPageMethodsMock(),
                basePlayByPlay: new BasePlayByPlayMock(),
                bettingPageMethods: new BettingPageMethodsMock(),
                userInfo: UserInfoMock
            }, new OddsMock(), BaseDict, config);
            // setup dictionary for debug build
            this.options.dict = BaseDict;
            //export data store to window for debug purposes
            window["MyPulseBetsDATA"] = this.dataProvider;
        }
        // if no provided dictionary is not full fill in the missing keys with the base one
        this.options.dict = Object.assign(Object.assign({}, BaseDict), (options.dict || {}));
        this.options.cms = Object.assign(Object.assign({}, config), (options.cms || {}));
        if (process.env.NODE_ENV === "production" && typeof options.dataProvider !== "undefined") {
            // use pagemethods passed during the construction from the
            // mobile application
            this.dataProvider = new MyPulseBetsData(options.dataProvider, options.oddsUtil, this.options.dict, this.options.cms);
        }
        // merge default and CMS options
    }
    activate() {
        return super.activate(React.createElement(MyPulseBets, { dataProvider: this.dataProvider, dict: this.options.dict }));
    }
}
window["MyPulseBets"] = MyPulseBetsRoot;
broadcastBlockLoad("MyPulseBets");
//# sourceMappingURL=index.js.map